import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'public',
        pathMatch: 'full'
    },
    {
        path: 'create',
        loadChildren: './tasks/create/create-task.module#CreateTaskModule',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'edit',
        loadChildren: './tasks/edit/edit-task.module#EditTaskModule',
        runGuardsAndResolvers: 'always'
    },
    {
        path: 'list',
        loadChildren: './tasks/list/list-task.module#ListTaskModule'
    },
    {
        path: 'public',
        loadChildren: './public/public.module#PublicPageModule'
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
